// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"99":"760eb20f","423":"66a6de0b","453":"60d8769f","585":"020776b9","787":"ce10da57"}[chunkId] + ".chunk.js";
};